(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecom-newsletter-advanced"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initNewsletterAdv(root) {
    if (!root || root.dataset.naInit === 'true') return;
    root.dataset.naInit = 'true';

    var form = root.querySelector('[data-newsletter-form-wrapper] form');
    if (!form) return;

    var field = root.querySelector('[data-newsletter-field]');
    var input = root.querySelector('[data-newsletter-input]');
    var submitBtn = root.querySelector('[data-newsletter-submit]');
    var inlineError = root.querySelector('[data-newsletter-inline-error]');
    var consent = root.querySelector('[data-newsletter-consent]');
    var wrapper = root.querySelector('[data-newsletter-form-wrapper]');

    var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function showInlineError(msg) {
      if (!inlineError) return;
      inlineError.textContent = msg;
      inlineError.hidden = false;
      if (field) field.classList.add('is-invalid');
    }
    function clearInlineError() {
      if (!inlineError) return;
      inlineError.hidden = true;
      inlineError.textContent = '';
      if (field) field.classList.remove('is-invalid');
    }
    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.disabled = isLoading;
      submitBtn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    if (input) {
      input.addEventListener('input', clearInlineError);
    }

    function bindCopyButtons(scope) {
      var btn = scope.querySelector('[data-newsletter-copy]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        var done = function () {
          btn.dataset.copied = 'true';
          var original = btn.textContent;
          btn.textContent = 'Copied!';
          setTimeout(function () {
            btn.textContent = original;
            btn.dataset.copied = 'false';
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () { fallbackCopy(code, done); });
        } else {
          fallbackCopy(code, done);
        }
      });
    }
    function fallbackCopy(text, done) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      done();
    }
    bindCopyButtons(root);

    form.addEventListener('submit', function (e) {
      clearInlineError();

      var emailValue = input ? input.value.trim() : '';
      if (!emailValue || !emailRe.test(emailValue)) {
        e.preventDefault();
        showInlineError('Please enter a valid email address.');
        if (input) input.focus();
        return;
      }
      if (consent && !consent.checked) {
        e.preventDefault();
        showInlineError('Please agree to continue.');
        return;
      }

      // Progressive enhancement: try a no-reload submit. If anything goes
      // wrong, fall back to a normal form post (full page reload).
      if (typeof fetch !== 'function' || typeof DOMParser !== 'function') return;

      e.preventDefault();
      setLoading(true);

      var formData = new FormData(form);
      fetch(form.action, { method: 'POST', body: formData, credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshRoot = doc.getElementById(root.id);
          if (!freshRoot) {
            form.submit();
            return;
          }
          var freshWrapper = freshRoot.querySelector('[data-newsletter-form-wrapper]');
          if (freshWrapper && wrapper) {
            wrapper.innerHTML = freshWrapper.innerHTML;
            var successEl = wrapper.querySelector('[data-newsletter-success]');
            var errorEl = wrapper.querySelector('[data-newsletter-error]');
            var focusTarget = successEl || errorEl;
            if (focusTarget) focusTarget.focus({ preventScroll: false });
            bindCopyButtons(wrapper);
          } else {
            form.submit();
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () { setLoading(false); });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-newsletter-section]').forEach(initNewsletterAdv);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecom-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {

  /* ── Carousel ── */
  document.querySelectorAll('.ecom-rv--carousel .ecom-rv__nav').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var trackId = btn.dataset.target;
      var track   = document.getElementById(trackId);
      if (!track) return;
      var cards   = track.querySelectorAll('.ecom-rv__card');
      var total   = cards.length;
      if (!total) return;

      var current = parseInt(track.dataset.current || '0');
      var dir     = parseInt(btn.dataset.dir);
      var next    = (current + dir + total) % total;

      track.dataset.current = next;
      track.style.transform = 'translateX(-' + (next * 100) + '%)';

      var dotsWrap = track.closest('.ecom-rv__carousel').querySelector('.ecom-rv__dots');
      if (dotsWrap) {
        dotsWrap.querySelectorAll('.ecom-rv__dot').forEach(function(d, i) {
          d.classList.toggle('ecom-rv__dot--active', i === next);
        });
      }
    });
  });

  document.querySelectorAll('.ecom-rv__dot').forEach(function(dot) {
    dot.addEventListener('click', function() {
      var trackId = dot.dataset.target;
      var track   = document.getElementById(trackId);
      if (!track) return;
      var idx = parseInt(dot.dataset.index);
      track.dataset.current = idx;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      dot.closest('.ecom-rv__dots').querySelectorAll('.ecom-rv__dot').forEach(function(d, i) {
        d.classList.toggle('ecom-rv__dot--active', i === idx);
      });
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
